const PREVIEW_DEBOUNCE_MS = 450;

export type PreviewDebounceController = {
  readonly schedule: (callback: () => void) => void;
  readonly cancel: () => void;
};

export const createPreviewDebounce = (
  delayMs = PREVIEW_DEBOUNCE_MS,
): PreviewDebounceController => {
  let timer: ReturnType<typeof setTimeout> | null = null;

  return {
    schedule(callback: () => void) {
      if (timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        timer = null;
        callback();
      }, delayMs);
    },
    cancel() {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
    },
  };
};
